module.exports = __webpack_public_path__ + "static/media/pic_1.1cd4b9ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/pic_1.png
// module id = 528
// module chunks = 0